import ExternalPostingForm from './ExternalPostingForm';

export default ExternalPostingForm;
